// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colors } from '../../shared/styles';
import logo from '../../images/logo.svg';

const StyledAppHeader = styled.div`
    background: white;
    padding: 20px;
    border-bottom: 1px solid ${colors.offWhite};

    img {
        float: right;
        height: 40px;
    }

    h1 {
        margin: 0;
        font-weight: normal;
    }

    h1 a {
        color: ${colors.blue};
        text-decoration: none;
    }
`;

const AppHeader = () => {
    return (
        <StyledAppHeader>
            <img src={logo} alt="Network Rail logo" />

            <h1>
                <Link to="/">Property Management</Link>
            </h1>
        </StyledAppHeader>
    );
};

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/shared/AppHeader.js